import React from "react";
import {filterOptions} from '../MetricsDetailUtils';
import styles from "../Utilities/Styles.module.css"

export const FilterOptionsDropdown = ({onSelectChangeHandler}) => {
    return (
        <div className={styles.filterOptionsDropdown}>
            {filterOptions.map(option =>
                <div
                    key={option.value}
                    className="filter-options-div"
                     onClick={() => onSelectChangeHandler(option)}>
                    {option.label}
                </div>
            )}
        </div>
    )
}